import { render, staticRenderFns } from "./EquipTypeNew.vue?vue&type=template&id=a997c8dc&scoped=true"
import script from "./EquipTypeNew.vue?vue&type=script&lang=js"
export * from "./EquipTypeNew.vue?vue&type=script&lang=js"
import style0 from "./EquipTypeNew.vue?vue&type=style&index=0&id=a997c8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a997c8dc",
  null
  
)

export default component.exports